"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformConfigData = transformConfigData;
var _orderSummaryData = _interopRequireDefault(require("./order-summary-data"));
var _productConfigurationData = _interopRequireDefault(require("./product-configuration-data"));
/**
 * Transforms raw configuration data into a structured format.
 *
 * @param {Object} rawData The raw data to be transformed.
 * @returns {Object} A transformed configuration object.
 */
function transformConfigData(rawData) {
  const responseData = rawData?.response;
  if (!responseData) return {};
  const {
    data,
    instance,
    environment,
    content,
    disclaimers
  } = responseData;
  const productKeys = Object.keys(instance);
  const orderSummaryData = (0, _orderSummaryData.default)(responseData);
  const productConfigurationData = (0, _productConfigurationData.default)(responseData);
  const {
    title,
    pageHeadline
  } = productKeys.length > 0 && data[productKeys[0]]?.content ? data[productKeys[0]].content : {};
  const transformed = {
    pageEyebrow: {
      pageTagLabel: content.addedToCart || 'Added to cart',
      pageTitle: title || 'Customize your plan'
    },
    itemSummary: {
      orderSummary: content?.orderSummary,
      total: content?.total,
      legalTaxText: content?.legalTaxText,
      totalSavingsBanner: content?.totalSavingsBanner,
      belowContinueToCartContent: content?.belowContinueToCartContent || [],
      fixedCheckoutDescription: content?.scrollToCart,
      totalPriceOrder: orderSummaryData.totalPriceOrder,
      totalSavingsOrder: orderSummaryData.totalSavingsOrder,
      items: productKeys.map(product => ({
        [product]: {
          totalPrice: orderSummaryData[product].totalPrice,
          totalSavings: orderSummaryData[product].totalSavings,
          selections: orderSummaryData[product].selections
        }
      }))
    },
    productConfiguration: {
      pageHeadline: pageHeadline || 'Product configuration',
      products: productConfigurationData
    },
    disclaimers,
    commonContent: content,
    instance,
    environment
  };
  return transformed;
}